<template>
  <h1 class="system_content_title">参评企业管理</h1>
  <div class="system_content_panels">
    <div class="systemPanel" style="position: relative; padding-bottom: 40px; width: 100%">
      <el-button style="margin-right: 10px;" type="success" @click="handleAdd(resetFormData)">添加企业</el-button>
      <el-input v-model="state.params.Value" @keyup.enter.native="handleInput" placeholder="请输入查询内容" input-style="width:20%;" />
      <el-button style="margin-left: 10px;" type="primary" @click="handleInput">搜索</el-button>
      <el-button type="default" @click="handleBack">返回上一级</el-button>
      <el-table v-loading="state.Loading" :data="state.tableData" stripe style="width: 100%">
        <el-table-column prop="companyName" label="企业名称" />
        <el-table-column prop="orgCode" label="信用代码" />
        <el-table-column prop="regionFullName" label="行政区划" />
        <el-table-column prop="score1" label="自评分" />
          <el-table-column prop="createTime" label="创建时间"  width="100">
            <template #default="scope">
          <span>{{scope.row.createTime.replace("T",' ')}}</span>
            </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="240">
          <template #default="scope">
             <el-popconfirm
            title="确定删除吗？"
            @confirm="deleteItem(scope.row.id)"
          >
            <template #reference>
              <el-button size="small" type="danger" style="margin-bottom: 2px"
                >删除</el-button
              >
            </template>
          </el-popconfirm>
            <el-button size="small" type="warning" @click="handleEdit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :page-sizes="[20, 60, 80, 100]" :page-size="state.params.rows" background
        layout="total, sizes, prev, pager, next, jumper" :total="state.total">
      </el-pagination>
    </div>
  </div>
  <!-- 添加企业 -->
   <el-dialog
      v-model="state.addVisible"
      title="添加企业"
      width="30%"
      :before-close="handleClose"
    >
      请选择用户：
      <el-select
        v-model="state.addCompanyList"
        filterable
        remote
        multiple
        placeholder="输入名称或信用代码"
        :remote-method="searchUser"
        :loading="state.addSearchLoading"
        style="margin-bottom: 10px"
      >
        <el-option
          v-for="item in state.userList"
          :key="item.id"
          :label="item.name + ' - ' + item.orgCode"
          :value="item.id"
        />
      </el-select>

      <template #footer>
        <span class="dialog-footer" style="margin: 0 auto">
          <el-button @click="handleAddClose">取消</el-button>
          <el-button
            type="primary"
            @click="addCompanies"
            :disabled="!state.addCompanyList"
            >确定</el-button
          >
        </span>
      </template>
    </el-dialog>
  <!-- 编辑内容 -->
  <el-dialog v-model="state.dialogEditVisible" title="编辑企业信息" :close-on-click-modal="false"
    :before-close="handleClose">
    <el-form label-width="120px" label-position="left">
      <el-form-item label="企业名称">
        <el-input v-model="state.companyName" placeholder="请输入企业名称" />
      </el-form-item>
      <el-form-item label="信用代码">
        <el-input v-model="state.orgCode" placeholder="请输入信用代码" />
      </el-form-item>
      <el-form-item label="行政区划">
        <el-cascader ref="cascaderRef" style="width: 100%;" v-model="state.regionValue" :props="{emitPath:false}"
          placeholder="请选择行政区划" :options="state.RegionOptions" @change="handleRegionChange" />
      </el-form-item>
      <!-- <el-form-item label="所属街道">
        <el-select style="width: 100%;" v-model="state.streetValue" placeholder="请选择所属街道">
          <el-option v-for="(item,index) in state.streetOptions" :key="index" :label="item.JieDao"
            :value="item.JieDao" />
        </el-select>
      </el-form-item> -->
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button type="primary" @click="handleEditSave">保存</el-button>
        <el-button @click="state.dialogEditVisible = false">取消</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import { useRouter ,useRoute} from "vue-router";
import { onMounted, getCurrentInstance, reactive, ref } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import api from "../../http/apis"
const router = useRouter();
const route=useRoute()
const data = JSON.parse(window.localStorage.getItem("data"));
const { proxy } = getCurrentInstance();
const resetFormData = ref(null);
const cascaderRef = ref(null)
const state = reactive({
  dialogVisible: false,
  dialogEditVisible: false,
  tableData: [],
  Loading: true,
  total: 0,
  params: {
    headId: data.id,
    value: "",
    page: 1,
    rows: 20,
    sort: "",
  },
  paramsCompany: {
    regionId: 2267,
    value: "",
    page: 1,
    rows: 100,
    order: "desc",
  },
  options: {},
  id: 0,
  companyName: '',
  orgCode: '',
  regionValue: '',
  streetValue: '',
  RegionOptions: [],
  streetOptions: [],
  addVisible:false,
  addCompanyList:[],
  addSearchLoading:false,
  userList:[],
});

onMounted(() => {
  getTableData();
  getQuerySCList();
});

    const handleAddClose = () => {
      state.addVisible = false;
      state.addSearch = "";
      state.addUser = "";
    };
const searchUser = async (e) => {
      state.addSearchLoading = true;
      const { data } = await api.companyApi.getGZCompanies({
        page: 1,
        rows: 399,
        order: "asc",
        sort: "",
        value: e,
      });
      console.info("search user", data);
      if (data.isSuccessful) {
        state.userList = data.resultObj.data;
      }
      state.addSearchLoading = false;
    };
// 获取行政区域
const getQuerySCList =async () => {
  const {data}=await api.companyApi.getGZRegionTree()


    if (data.isSuccessful) {
      getTreeData(data.resultObj, state.RegionOptions);
      // console.log(state.RegionOptions);
    } else {
      ElMessage({
        message: data.resultMsg,
        type: "error",
      });
    }

};
 const deleteItem = async (id) => {
      state.addSearchLoading = true;
      const { data } = await api.reviewTaskApi.deleteCompanyFromTask(id);
      console.info("search user", data);
      if (data.isSuccessful) {
        ElMessage({
          message: data.resultMsg,
          type: "success",
        });
        getTableData();
      } else {
        ElMessage({
          message: data.resultMsg || "未知错误",
          type: "error",
          grouping: true,
        });
      }
      state.addSearchLoading = false;
    };
// 重构行政区域
const getTreeData = (data, arr) => {
  data.forEach((item, index) => {
    arr.push({
      value: item.id,
      label: item.name,
    });
    if (item.children.length > 0) {
      arr[index].children = [];
      getTreeData(item.children, arr[index].children);
    } else {
      delete arr[index].children;
    }
  });
};
 const addCompanies = async () => {
      //  const idArr=state.addCompanyList.map(item=>{

      //       return {
      //         id:item
      //       }
      //      })
      let idArr = [];
      state.addCompanyList.forEach((itemID) => {
        state.userList.forEach((companyItem) => {
          if (companyItem.id == itemID) {
            idArr.push({
              id: companyItem.id,
              name:companyItem.name,
              regionFullName:companyItem.regionFullName,
              regionId:companyItem.regionId,
              orgCode:companyItem.orgCode
            });
          }
        });
      });
  

      const { data } = await api.reviewTaskApi.addCompaniesToTask(
        route.query.taskid,
        idArr
      );
      console.info("addCompany", data);
      if (data.isSuccessful) {
        ElMessage({
          message: "操作成功",
          type: "success",
        });
        handleAddClose();
        getTableData();
      } else {
        ElMessage({
          message: data.resultMsg || "未知错误",
          type: "error",
          grouping: true,
        });
      }
    };

const handleRegionChange = () => {
  let name = cascaderRef.value.getCheckedNodes()[0].label;
  let regionFullNameArr=['贵州省']
cascaderRef.value.getCheckedNodes()[0].pathLabels.forEach(item=>{
  regionFullNameArr.push(item)
})
state.regionFullName=regionFullNameArr.join('/')
console.info()
  // handleGetStreet(name)
}

const handleGetStreet = (name) => {
  proxy.$httpApi.getQueryRegionLoadList(name).then((res) => {
    if (res.IsSuccessful) {
      if (res.ResultObj.length === 0) {
        state.streetValue = ''
        state.streetOptions = []
      } else {
        state.streetOptions = res.ResultObj
      }
    } else {
      ElMessage({
        message: res.ResultMsg,
        type: "error",
      });
    }
  });
}

const handleSelect = (val) => {
  state.options = {
    appraiseId: data.id,
    baseCompanyId: val.id,
    regionFullName: val.RegionFullName,
    regionId: val.RegionId,
    companyName: val.Name,
    orgCode: val.orgCode
  };
  console.log(state.options);
};

const handleBack = () => {
  // 返回上一级
  router.push("/system/worktask/indexPage");
};

const handleAdd = (formEl) => {
  state.addVisible = true;
  if (!formEl) return;
  resetFormData.value.resetFields();
}

const handleEdit = (row) => {
  console.info('row',row)
  state.dialogEditVisible = true
  state.id = row.baseCompanyId
  state.companyName = row.companyName
  state.orgCode = row.orgCode
  state.regionValue = row.regionId
  state.regionFullName = row.regionFullName
  // state.streetValue = row.jieDao
  // if (row.regionFullName) {
  //   let name = row.regionFullName.slice(row.regionFullName.lastIndexOf("/") + 1);
  //   handleGetStreet(name)
  // }
}

const handleClose = (done) => {
  // 关闭窗口
  done();
}

const handleInput = () => {
  state.params.Value = state.params.Value.trim() 
  getTableData()
}

const getTableData = async () => {
  // 获取列表数据
  state.Loading = true;
  const {data}=await api.reviewTaskApi.getCompaniesByTaskID(state.params)

  if (data.isSuccessful) {
      state.Loading = false;
      state.tableData = data.resultObj.data;
        console.info('tabledata',state.tableData)
      state.total = data.resultObj.pagerInfo.totalRowCount;
    } else {
      ElMessage({
        message: data.resultMsg,
        type: "error",
      });
      state.Loading = false;
    }
};

const handleDel = (id) => {
  // 删除
  ElMessageBox.confirm("是否确认删除?", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(() => {
      proxy.$httpApi.delAppraiseCompany(id).then((res) => {
        if (res.IsSuccessful) {
          ElMessage({
            message: res.ResultMsg,
            type: "success",
          });
          state.dialogVisible = false;
          getTableData();
        } else {
          ElMessage({
            message: res.ResultMsg,
            type: "error",
          });
        }
      });
    })
    .catch(() => {
      ElMessage({
        type: "info",
        message: "您已取消删除",
      });
    });
};

const handleSave = () => {
  proxy.$httpApi.saveAppraiseCompany(state.options).then((res) => {
    if (res.IsSuccessful) {
      ElMessage({
        message: res.ResultMsg,
        type: "success",
      });
      state.dialogVisible = false;
      getTableData();
    } else {
      ElMessage({
        message: res.ResultMsg,
        type: "error",
      });
    }
  });
};

const handleEditSave =async () => {
  const dataObj = {
    id: state.id,
    name: state.companyName,
    orgCode: state.orgCode,
    regionId: state.regionValue,
  regionFullName:state.regionFullName
  }
 
const {data}=await api.reviewTaskApi.changeTaskCompanyInfo(dataObj)
  
    if (data.isSuccessful) {
      ElMessage({
        message: data.resultMsg,
        type: "success",
      });
      state.dialogEditVisible = false;
      getTableData();
    } else {
      ElMessage({
        message: data.resultMsg,
        type: "error",
      });
    }
  
}



const handleSizeChange = (val) => {
  state.params.rows = val
  getTableData()
}

const handleCurrentChange = (val) => {
  state.params.Page = val
  getTableData()
}

</script>

<style lang="sass" scoped>
@use "../../assets/scss/departmentManagement.scss" as *
</style>